import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-hra-coverage-settings",
    prompt: (guidanceItem) =>  `Select the items and services your ${guidanceItem.parameters.planShortName} plan will cover. You may choose one of our common combinations from the drop down menu. For custom setups, please add a note in the Claim Processing Notes section, which you will find in the Notes drop-down row at the bottom of this window.`,
    briefDescription: 'HRA Coverage Settings',
    openAction: {
        text: "View Plan Coverage",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Coverage"
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-hra-coverage-settings.js